<template>
	<div class="class-management-box">
		<!-- 班级管理 -->
		<div class="nianji-box">
			<div class="fuzzy-matching-content">
				<el-button type="primary" @click="AddClick">新增班级</el-button>
				<el-button type="primary" @click="banjifanhui">返回</el-button>
			</div>
			<div class="fuzzy-matching-bottom">
				<el-table v-loading="loading" :border="true" class="table-Style"
					:header-cell-style="{ background: '#F4F7FC', color: '#000', }" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column prop="name" label="名称">
					</el-table-column>
					<el-table-column prop="studentCount" label="学生人数">
					</el-table-column>
					<el-table-column prop="teacherCount" label="教师人数">
					</el-table-column>
					<el-table-column prop="created" label="添加时间">
					</el-table-column>
					<el-table-column label="操作" min-width="100">
						<template #default="scope">
							<!-- <el-button type="text" size="small" @click="classManagement(scope.row)">修改班级</el-button> -->
							<el-button type="text" size="small" class="searchBtn "
								@click="settingTeacher(scope.row)">设置班主任/老师</el-button>
							<el-button type="text" size="small" class="searchBtn"
								@click="xiugaiClick(scope.row)">修改</el-button>
							<el-button type="text" size="small" class="shanchuBtn"
								@click="deleteClick(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="zuzhiblock-fenye">
				<el-pagination layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</div>
		<el-dialog class="dia-log-box" :title="title" v-model="dialogVisible" width="30%" :before-close="handleClose">
			<el-form ref="form" :model="form" :rules="rules">
				<el-form-item label="名称:" prop="schoolName" label-width="100px">
					<el-input v-model="form.schoolName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注:" label-width="100px">
					<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.remark">
					</el-input>
				</el-form-item>
				<div class="buttom-box">
					<el-button type="primary" class="addForm" @click="onSubmit('form')">提交</el-button>
					<el-button @click="handleClose">返回</el-button>
				</div>
			</el-form>
		</el-dialog>
		
		<el-dialog class="dia-log-box" title="设置班主任/老师" v-model="dialogSTVisible" width="30%" :before-close="handleSTClose">
			<el-form ref="Dform" :model="Dform">
				<el-form-item v-for="(item, index) in subjectList" :key="index" :label="item.id == 0 ? item.name : item.name + '老师'" label-width="200">
					<el-select v-model="Dform[item.id]" filterable placeholder="请选择老师" multiple>
						<el-option v-for="item in teacheerList" :key="item.id" :label="item.name + ' | ' + item.mobile" :value="item.type + '|' + item.id"></el-option>
					</el-select>
				</el-form-item>
				<div class="buttom-box">
					<el-button type="primary" class="addForm" @click="onSubmitST">提交</el-button>
					<el-button @click="handleSTClose">返回</el-button>
				</div>
			</el-form>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		getFindClassList,
		getTeacherSubject,
		addClass,
		findClassInfo,
		schoolClassupdate,
		schooldeleteClass,
		getTeacherList
	} from '@/assets/api/renyuan';
  	import { subjectList, addTeacherJob} from '@/assets/api/schoollog';
	export default {
		components: {},
		props: ['ClassObj'],
		data() {
			return {
				tableData: [{
					name: '123123'
				}],
				loading: true,
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				subjectList:[],
				teacheerList:[],
				total: '',
				classId: '',
				Dform:{},
				form: {
					remark: "",
					schoolName: ''
				},
				rules: {
					schoolName: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
				},
				title: '新增班级',
				dialogVisible: false,
				dialogSTVisible: false,
				orgId:"",
			};
		},
		created() {
			// console.log( this.ClassObj,'班级传送');
			this.Classlist()
		},
		mounted() {

		},
		methods: {
			banjifanhui() {
				this.$emit('banjifanhui')
			},
			
			handleClose() {
				this.dialogVisible = false
				this.Classlist()
			},
			
			handleSTClose(){
				this.dialogSTVisible = false
				this.Dform = {};
			},
			// 校验
			onSubmit(formName) {
				// console.log(formName);
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.title == '修改班级') {
							// console.log('修改', 8888);
							this.classXiugai()
						} else if (this.title == '新增班级') {
							this.ClassAddForm()
						}
					} else {
						console.log('校验不通过');
					}
				});
			},
			// 删除
			deleteClick(item) {
				this.$confirm('确定删除该班级?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					schooldeleteClass(item.id).then((res) => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});
						this.Classlist()
					}).catch((err) => {
						this.$message({
							type: 'error',
							message: err.response.data.msg
						});
					
					})
				})
			},
			//列表
			Classlist() {
				const params = {
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize
				}
				getFindClassList(params, this.ClassObj.id).then((res) => {
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.loading = false;
					// console.log(res,'班级列表');
				}).catch((err) => {
					// console.log(err,'班级列表');
				})
			},
			// x新增弹框
			AddClick() {
				this.title = '新增班级'
				this.dialogVisible = true
			},
			//新增
			ClassAddForm() {
				const params = {
					id: this.ClassObj.id,
					name: this.form.schoolName,
					remark: this.form.remark,
				}
				addClass(params).then((res) => {
					// console.log(res,'新增成功');
					this.$message({
						type: 'success',
						message: "新增成功"
					});
					this.handleClose()

				}).catch((err) => {
					// console.log(err,'新增失败');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});

				})
			},
			
			//设置教师
			settingTeacher(item){
				this.classId = item.id;
				this.getSubjectList();
				this.getTeacherList();
				this.getTeacherSubject();
				this.dialogSTVisible = true;
			},
			
			getTeacherSubject(){
				getTeacherSubject(this.classId).then((res) => {
					const teacherList = res.data.data;
					console.log(JSON.stringify(teacherList));
					if(teacherList != null){
						let dataList = [];
						teacherList.forEach((item)=>{
							let dataItem = {};
							let teacherItem = [];
							item.teacherList.forEach((tL)=>{
								teacherItem.push(`${tL.type}|${tL.id}`)
							});
							if(item.subjectId == null || item.subjectName == null){
								dataItem = { "0" : teacherItem };
							}else{
								dataItem = {[item.subjectId] : teacherItem} ;
							}
							dataList = {...dataList,...dataItem}
						})
						
						this.Dform = dataList;
					}
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			
			getSubjectList(){
				//获取学科列表
				let params = {
					schoolId: this.ClassObj.schoolId,
				}
				subjectList(params).then((res) => {
					this.subjectList = res.data.data;
					this.subjectList.splice(0, 0, {id:"0",name:'班主任'});
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			
			getTeacherList(){
				//获取老师列表
				const params = {
					name: "",
					schoolId: this.ClassObj.schoolId
				}
				getTeacherList(params).then((res) => {
					this.teacheerList = res.data.data;
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			
			onSubmitST(){
				console.log(this.subjectList);
				const teacherList = this.convertJsonToSubjectTeacher(this.Dform);
				let str = ''
				str = teacherList.find(item => item.subject === "0");
				console.log(teacherList,888888,str);

				if ( str == undefined  ) return this.$message({type: 'error',message: '班主任必选！'});
				const params = [];
					const jobOrgMap = { 1: { job: 1}, 2: { job: 2}, 3: { job: 3}, 4: { job: 4}};
					teacherList.forEach((item) => {
					const [type, teacherId] = item.teacherId.split("|");
					const config = jobOrgMap[type];
					if (config && teacherId) {
						params.push({
						job: item.subject == 0 ? "3" :config.job,
						orgId: this.classId,
						subject: item.subject == 0 ? undefined : item.subject,
						teacherId
						});
					}
					});
					
					addTeacherJob(params).then((res) => {
						this.handleSTClose();
						this.$message({
							type: 'success',
							message: "设置成功"
						});
					}).catch((err) => {
						this.$message({
							type: 'error',
							message: err.response.data.msg
						});
					})
				
			},
			
			convertJsonToSubjectTeacher(jsonData) {
			   const result = [];
			    for (const [key, values] of Object.entries(jsonData)) {
			       // 遍历每个键对应的所有值
			       values.forEach(value => {
			         result.push({
			           subject: key,
			           teacherId: value
			         });
			       });
			     }
			     return result;
			},
			
			
			// 修改弹框详情
			xiugaiClick(item) {
				this.title = '修改班级'
				this.dialogVisible = true
				findClassInfo(item.id).then((res) => {
					console.log(res, '修改');
					this.form.schoolName = res.data.data.name
					this.form.remark = res.data.data.description
					this.classId = res.data.data.id
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			// 修改
			classXiugai() {
				const params = {
					id: this.classId,
					name: this.form.schoolName,
					remark: this.form.remark,
				}
				schoolClassupdate(params).then((res) => {
					console.log(res, '修改成功');
					this.$message({
						type: 'success',
						message: "修改成功"
					});
					this.handleClose()
				}).catch((err) => {
					console.log(err, '修改失败');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.Classlist()
			},
		},
	};
</script>

<style scoped lang="scss">
	.class-management-box {
		height: 100%;
		padding-top: 20px;

		.nianji-box {
			height: 100%;
		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 20px;

			/deep/ {
				.el-button {
					margin-left: 50px;
					font-size: 16px;
					height: 30px;
					// background-color: #1BC896;

				}
			}
		}

		.fuzzy-matching-bottom {
			// position: absolute;
			height: 70%;
			overflow: auto;
			padding: 20px;

			.table-Style {
				// border-radius: 15px;
			}

			.searchBtn {
				font-size: 15px;
				font-weight: 700;
				// color: #1BC896;
			}
			.headmaster-box {
				color: #000;
				font-weight: 600;
			}
			.shanchuBtn {
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			/deep/ {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 15px;
					font-weight: 700;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 40px;
					line-height: 40px;
					border: 0;
					font-size: 16px;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					border: 0;
				}

				.el-button--small {
					padding-left: 19px;
				}
			}

		}

		.zuzhiblock-fenye {
			margin-left: 1000px;
			margin-top: 15px;
		}

		/deep/ {
			.el-dialog {

				.el-input--small .el-input__wrapper {
					height: 35px;
					line-height: 35px;
					text-align: center;
					width: 280px;
				}
				
				.el-input--small {
					width: 250px;
				}
								
				.el-select .el-input__inner {
					height: 35px;
					line-height: 35px;
				}
								
				.el-form-item--small .el-form-item__label {
					height: 35px;
					line-height: 35px;
					font-size: 16px;
					font-weight: 700;
				}

								
				.el-input__inner {
					height: 35px;
					line-height: 35px;
				}
				
				.el-radio.el-radio--small .el-radio__inner {
					width: 14px;
					height: 14px;
				}
				
				.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}
				
				.el-date-editor.el-input,
				.el-date-editor.el-input__wrapper {
					height: 35px !important;
				}
				
				.el-select--small .el-select__wrapper {
					width: 250px;
					height: auto;
					min-height: 35px;
				}
				

				.buttom-box {
					// text-align: center;
					margin-left: 180px;

					.addForm {
						// background-color: #1BC896;
					}
				}

				.el-form-item--small {
					width: 70% !important;
				}
			}
		}
	}
</style>